import { api, unwrapData } from '../../app/store/api';
import {
    ApiResponse,
    PaginatedResponse,
    NewsItemType,
    SettingsModel,
} from '../../types';

export const systemApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getData: builder.query<SettingsModel, void>({
            transformResponse: unwrapData,
            query: () => ({
                url: 'system/data',
            }),
        }),

        newsList: builder.query<
            PaginatedResponse<NewsItemType>,
            { page?: number; perPage?: number }
        >({
            transformResponse: unwrapData,
            query: ({ page, perPage = 15 }) => ({
                url: 'user/news',
                method: 'GET',
                params: {
                    ...(page && { page }),
                    ...(perPage && { per_page: perPage }),
                },
            }),
            providesTags: ['News'],
        }),

        lastNews: builder.query<any, void>({
            transformResponse: unwrapData,
            query: () => ({
                url: 'user/news/latest',
            }),
            providesTags: ['News'],
        }),

        newsSeen: builder.mutation<any, number>({
            transformResponse: unwrapData,
            query: (id) => ({
                url: `user/news/${id}`,
                method: 'PATCH',
            }),
            invalidatesTags: (result) => (result ? [{ type: 'News' }] : []),
        }),
        newsAllSeen: builder.mutation<any, void>({
            transformResponse: unwrapData,
            query: () => ({
                url: `user/news`,
                method: 'PATCH',
            }),
            invalidatesTags: (result) => (result ? [{ type: 'News' }] : []),
        }),
    }),
});

export const {
    useGetDataQuery,
    useNewsListQuery,
    useLastNewsQuery,
    useNewsSeenMutation,
    useNewsAllSeenMutation,
} = systemApi;
